/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import React from 'react';

/**
 * MaterialRounded Supervised User Circle (`grey-600`) overlaid with MaterialRounded List (`white`) on a `grey-400` background.
 * @export
 */
export const ICON_SUPERVISED_USER_CIRCLE_WITH_LIST = (
  <svg fill="none" height="176" viewBox="0 0 177 176" width="177" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0.5 88C0.5 39.3989 39.8989 0 88.5 0C137.101 0 176.5 39.3989 176.5 88V144C176.5 161.673 162.173 176 144.5 176H88.5C39.8989 176 0.5 136.601 0.5 88Z"
      fill="#F5F5F5"
    />
    <path
      clipRule="evenodd"
      d="M88.5 34.0002C60.9 34.0002 38.5 56.4002 38.5 84.0002C38.5 111.6 60.9 134 88.5 134C116.1 134 138.5 111.6 138.5 84.0002C138.5 56.4002 116.1 34.0002 88.5 34.0002ZM106.55 65.7004C111.9 65.7004 116.2 70.0004 116.2 75.3504C116.2 80.7004 111.9 85.0004 106.55 85.0004C101.2 85.0004 96.9 80.7004 96.9 75.3504C96.85 70.0004 101.2 65.7004 106.55 65.7004ZM88.3503 69.6004C88.3503 63.1004 83.0503 57.8004 76.5503 57.8004C70.0003 57.8004 64.7503 63.0504 64.7503 69.6004C64.7503 76.1004 70.0503 81.4004 76.5503 81.4004C83.0503 81.4004 88.3503 76.1004 88.3503 69.6004ZM76.5498 103.45V122.2C64.5498 118.45 55.0498 109.2 50.8498 97.3998C56.0998 91.7998 69.1998 88.9498 76.5498 88.9498C79.1998 88.9498 82.5498 89.3498 86.0498 90.0498C77.8498 94.3998 76.5498 100.15 76.5498 103.45ZM84.5497 123.801C85.8497 123.951 87.1497 124.001 88.4997 124.001C105.45 124.001 119.9 113.401 125.75 98.5505C121.15 94.7505 111.9 92.8005 106.55 92.8005C99.2497 92.8005 84.5497 96.3505 84.5497 103.451V123.801Z"
      fill="#707070"
      fillRule="evenodd"
    />
    <circle cx="133" cy="132" fill="#F5F5F5" r="29" />
    <path
      d="M132.5 107.833C119.136 107.833 108.333 118.636 108.333 132C108.333 145.364 119.136 156.167 132.5 156.167C145.864 156.167 156.667 145.364 156.667 132C156.667 118.636 145.864 107.833 132.5 107.833Z"
      fill="#BABABA"
    />
    <rect fill="white" height="4" rx="2" width="4" x="119.5" y="122" />
    <rect fill="white" height="4" rx="2" width="4" x="119.5" y="130" />
    <rect fill="white" height="4" rx="2" width="4" x="119.5" y="138" />
    <rect fill="white" height="4" rx="2" width="18" x="127.5" y="122" />
    <rect fill="white" height="4" rx="2" width="18" x="127.5" y="130" />
    <rect fill="white" height="4" rx="2" width="18" x="127.5" y="138" />
  </svg>
);
